const IMAGES = {
    domain_icon : new URL('./domain_circle_noWhite.png', import.meta.url).href,
    rea_icon : new URL('./REA_icon.png', import.meta.url).href,
    mw_icon : new URL('./mw_circle.png', import.meta.url).href,
    mw_icon_castle : new URL('./MW-logoIcon-white.svg', import.meta.url).href,
    domain_square_icon : new URL('./domain_icon.png', import.meta.url).href,
    logo_mark: new URL('./word and logo mark@2x.svg', import.meta.url).href,
    green_thumb: new URL('./green-thumb-up.svg', import.meta.url).href,
    red_thumb: new URL('./red-thumb-down.svg', import.meta.url).href,
    neutral_bidder: new URL('./yelow-alert.png', import.meta.url).href,
    map_bayside: new URL('./Bayside-map.png', import.meta.url).href,
    map_bayside_svg: new URL('./Bayside-map.svg', import.meta.url).href,
    bd_mri_icon: new URL('./B_D_icon.png', import.meta.url).href
}

export default IMAGES;